import React from 'react';
import Icon from '../../../components/AppIcon';

const SystemStatusCard = () => {
  const systemStatus = [
    {
      id: 1,
      label: 'Database',
      status: 'operational',
      icon: 'Database',
      message: 'All systems operational'
    },
    {
      id: 2,
      label: 'Storage',
      status: 'operational',
      icon: 'HardDrive',
      message: '78% capacity used'
    },
    {
      id: 3,
      label: 'API Services',
      status: 'operational',
      icon: 'Zap',
      message: 'Response time: 142ms'
    },
    {
      id: 4,
      label: 'Email Service',
      status: 'operational',
      icon: 'Mail',
      message: 'Delivery rate: 99.8%'
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'operational':
        return 'text-success';
      case 'degraded':
        return 'text-warning';
      case 'down':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden shadow-sm">
      <div className="px-6 py-4 border-b border-border">
        <h2 className="text-lg font-semibold text-foreground">System Status</h2>
        <p className="text-sm text-muted-foreground mt-1 font-caption">
          Platform health monitoring
        </p>
      </div>
      <div className="divide-y divide-border">
        {systemStatus?.map((item) => (
          <div key={item?.id} className="px-6 py-4">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <Icon name={item?.icon} size={16} className="text-muted-foreground" />
                <span className="text-sm font-medium text-foreground">{item?.label}</span>
              </div>
              <div className="flex items-center gap-1">
                <div
                  className={`w-2 h-2 rounded-full ${getStatusColor(item?.status)?.replace(
                    'text-',
                    'bg-'
                  )}`}
                />
                <span className={`text-xs font-medium capitalize ${getStatusColor(item?.status)}`}>
                  {item?.status}
                </span>
              </div>
            </div>
            <p className="text-xs text-muted-foreground font-caption">{item?.message}</p>
          </div>
        ))}
      </div>
      <div className="px-6 py-4 border-t border-border bg-muted/30">
        <button className="text-sm text-primary hover:underline font-medium">
          View detailed status →
        </button>
      </div>
    </div>
  );
};

export default SystemStatusCard;